import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { FeaturesBlock } from './FeaturesBlock';

type FeaturesBlockStrapiProps = {
  features: {
    title: string;
    description: string;
  }[];
};

export const FeaturesBlockStrapi = ({
  block,
}: BlockComponentModel<FeaturesBlockStrapiProps>) => {
  return <FeaturesBlock features={block.features} />;
};
